import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CounterPill, Stack, Typography } from '@lyearn/ui';

import ItemContent from '../AsyncFilter/ItemContent';
import { FilterOption, ItemRendererType } from '../types';

interface SelectedItemsProps {
  filterValue: FilterOption[];
  selectedOptions: FilterOption[];
  itemRenderer?: ItemRendererType;
  toggleOption: (val: FilterOption) => void;
}

const SelectedItems = (props: SelectedItemsProps) => {
  const { selectedOptions, itemRenderer, toggleOption, filterValue } = props;
  const { t } = useTranslation();

  const selectedOptionsIds = selectedOptions.map((item) => item.value);

  return (
    <Stack direction="col">
      <Stack alignItems="center" className="pt-12 me-18 ms-20" justifyContent="between">
        <Typography as="p" color="text-text-placeholder" variant="label-caps">
          {t('Common:Selected')}
        </Typography>
        <CounterPill label={selectedOptions.length} size="small" />
      </Stack>
      <Stack direction="col">
        {filterValue.map((option, index) => {
          return (
            <ItemContent
              key={`selected-${option.value}`}
              isLast={filterValue.length - 1 === index}
              isSelected={selectedOptionsIds.includes(option.value)}
              itemRenderer={itemRenderer}
              option={option}
              onClick={toggleOption}
            />
          );
        })}
      </Stack>
      <Typography
        as="p"
        className="mx-20 mt-8 mb-2 flex-shrink-0 pt-8"
        color="text-text-placeholder"
        variant="label-caps">
        {t('Common:All')}
      </Typography>
    </Stack>
  );
};

export default SelectedItems;
